import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm1.8-3a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0Z"
      clip-rule="evenodd"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12.959 21.046c-.318.316-.639.634-.959.954l-.005-.005c-.319-.319-.637-.635-.954-.948C7.385 17.42 4 14.064 4 10a8 8 0 1 1 16 0c0 4.064-3.385 7.421-7.041 11.046ZM18.8 10c0 1.829-.824 3.572-2.25 5.425-1.207 1.566-2.75 3.098-4.42 4.754l-.13.128-.13-.128c-1.67-1.656-3.213-3.188-4.42-4.754C6.025 13.572 5.2 11.829 5.2 10a6.8 6.8 0 1 1 13.6 0Z"
      clip-rule="evenodd"
    />
  </svg>
`;
